import { useEffect, useState } from "react";
import { Card, Row, Col, Spin, Empty, Typography } from "antd";
import api from "../../services/api";
import { useParams, useNavigate } from "react-router-dom";

const { Title } = Typography;

export default function SubCategoryListing() {
  const { categoryId } = useParams();

  const navigate = useNavigate();

  const [subcategoryTitle, setSubcategoryTitle] =
    useState("Sub Categories");

  const [subCategories, setSubCategories] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (categoryId) {
      loadSubCategories(categoryId);
      loadCategoryTitle(categoryId);
    }
  }, [categoryId]);

  const loadCategoryTitle = async (subcategoryId) => {
      try {
        const res = await api.get("/categories");

        const categories = res.data || [];

        const matchedCategory = categories.find((cat) =>
          cat.id === Number(subcategoryId)
        );

        if (matchedCategory) {
          setSubcategoryTitle(matchedCategory.name);
        }
      } catch (err) {
        console.error(err);
      }
    };

  const loadSubCategories = async (categoryId) => {
    setLoading(true);

    try {
      const res = await api.get(
        `/catalog/public/subcategories?category_id=${categoryId}`
      );

      setSubCategories(res.data || []);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: 20 }}>
      <Title level={4}>{subcategoryTitle}</Title>

      <div style={{ marginTop: 20 }}>
        {loading ? (
          <div
            style={{
              textAlign: "center",
              marginTop: 50,
            }}
          >
            <Spin size="large" />
          </div>
        ) : subCategories.length === 0 ? (
          <Empty description="No SubCategories Found" />
        ) : (
          <Row gutter={[16, 16]}>
            {subCategories.map((item) => (
              <Col
                xs={24}
                sm={12}
                md={8}
                lg={4}
                key={item.id}
              >
                <Card
                  hoverable
                  onClick={() => {
                    navigate(
                      `/product-list?category_id=${categoryId}&subcategory_id=${item.id}`
                    );
                  }}
                  cover={
                    <img
                      alt={item.name}
                      src={`${process.env.REACT_APP_API_URL}${
                        item.image ||
                        "/uploads/placeholder.jpg"
                      }`}
                      style={{
                        height: "auto",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                  }
                >
                  <h3 title={item.name}>{item.name}</h3>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </div>
    </div>
  );
}